import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { CATALOGS } from '../../resources/lang/registry.generated';
import LocalizationManager, { FALLBACK_LANGUAGE, SUPPORTED_LOCALES } from './LocalizationManager';
import { Settings } from 'luxon';
import dayjs from 'dayjs';
import { antdLocaleFor } from './antdLocale';

// Before the brand is known. BrandProvider re-aligns the language with the brand as
// soon as it settles (see brandLanguages.js).
const DEFAULT_LANGUAGE = FALLBACK_LANGUAGE;

const languageDetector = {
  type: 'languageDetector',
  // If this is set to true, your detect function receives a callback function that you should call with your language,
  // useful to retrieve your language stored in AsyncStorage for example
  async: true,

  init: (_services, _detectorOptions, _i18nextOptions) => {
    /* use services and options */
  },
  detect: (callback) => {
    const languageFromUrl = LocalizationManager.getLanguageFromUrl();

    if (languageFromUrl) {
      return callback(languageFromUrl);
    }

    const browserLanguage = LocalizationManager.getLanguage();

    if (!browserLanguage) {
      const preferredLanguage = LocalizationManager.getPreferredLanguage();

      if (!preferredLanguage) {
        return callback(DEFAULT_LANGUAGE);
      }

      return callback(preferredLanguage);
    }

    return callback(browserLanguage);
  },
  cacheUserLanguage: (lng) => {
    // Cache language if necessary
    LocalizationManager.saveLanguage(lng);
    Settings.defaultLocale = lng;
    dayjs.locale(antdLocaleFor(lng).dayjs);
  },
};

i18n
  .use(languageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: CATALOGS,
    // Every SUPPORTED_LOCALES entry ships a bundle (CATALOGS, from the generated registry).
    // The fallback stays because a key added to en/ before the pipeline re-runs is missing
    // from the other languages — it renders its English copy rather than a raw i18n key.
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LOCALES,
    nonExplicitSupportedLngs: true,
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
  });

// antd's date components (DateFilter's RangePicker) format with dayjs, which keeps one
// global locale; Luxon above only covers this app's own formatting.
i18n.on('languageChanged', (lng) => {
  dayjs.locale(antdLocaleFor(lng).dayjs);
});
